const BUILD_FLAG = String(import.meta.env.VITE_SANDBOX ?? '').toLowerCase() === 'true';

const CONFIGURED_HOSTS = String(import.meta.env.VITE_SANDBOX_HOSTS ?? '')
  .split(',')
  .map((h) => h.trim().toLowerCase())
  .filter(Boolean);

const IS_DEV_BUILD = Boolean(import.meta.env.DEV);

function hostnameLooksLikeSandbox(hostname: string): boolean {
  const host = hostname.toLowerCase();
  if (CONFIGURED_HOSTS.includes(host)) return true;
  if (/^sandbox[.-]/.test(host)) return true;
  if (/(^|\.)sandbox(\.|$)/.test(host)) return true;
  return false;
}

export function isSandboxMode(): boolean {
  if (BUILD_FLAG) return true;

  if (typeof window === 'undefined') return false;

  if (window.location?.hostname && hostnameLooksLikeSandbox(window.location.hostname)) {
    return true;
  }

  if (IS_DEV_BUILD) {
    try {
      const params = new URLSearchParams(window.location.search);
      const flag = (params.get('sandbox') ?? '').toLowerCase();
      if (flag === '1' || flag === 'true') return true;
      if (sessionStorage.getItem(SANDBOX_SESSION_KEY) === '1') return true;
    } catch {
    }
  }

  return false;
}

export const SANDBOX_SESSION_KEY = 'wenext_sandbox_mode';

export function persistSandboxOptIn(): void {
  if (!IS_DEV_BUILD || typeof window === 'undefined') return;
  try {
    const params = new URLSearchParams(window.location.search);
    const flag = (params.get('sandbox') ?? '').toLowerCase();
    if (flag === '1' || flag === 'true') {
      sessionStorage.setItem(SANDBOX_SESSION_KEY, '1');
    }
  } catch {
  }
}
